import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap } from 'lucide-react';
import { useAuth } from '@shared/auth/AuthContext';

export const BrandBlock: React.FC = () => {
  const { tenant } = useAuth();

  return (
    <Link
      to="/"
      className="flex items-center gap-2.5 text-navbar-foreground hover:opacity-90 transition-opacity shrink-0"
      title={tenant?.name ? `${tenant.name} (${tenant.slug})` : 'Helios-Coach'}
    >
      <div className="flex h-7 w-7 items-center justify-center rounded-md bg-primary text-primary-foreground shadow-sm">
        <GraduationCap className="h-4 w-4" />
      </div>
      <div className="flex items-center gap-1.5 font-bold tracking-tight text-sm">
        <span>HELIOS</span>
        <span className="rounded bg-primary/20 px-1.5 py-0.2 text-[10px] font-semibold text-primary-foreground tracking-normal uppercase">
          Coach
        </span>
        {tenant?.name && (
          <>
            <span className="text-navbar-muted font-light">/</span>
            <span className="hidden sm:inline font-medium text-navbar-muted text-xs truncate max-w-[140px]">
              {tenant.name}
            </span>
          </>
        )}
      </div>
    </Link>
  );
};
